export interface Alert {
    assignedTo: string;
    body: string;
    createdBy: string;
    createdByName: string;
    creationDate: Date;
    highPriority: boolean;
    id: number;
    readDate?: Date;
    relatedData: string;
    relatedDataId?: number;
    toRedirect?: boolean;
}

export class AlertWithTimediff implements Alert {
    assignedTo: string;
    body: string;
    createdBy: string;
    createdByName: string;
    creationDate: Date;
    highPriority: boolean;
    id: number;
    readDate?: Date | undefined;
    relatedData: string;
    relatedDataId?: number | undefined;
    toRedirect?: boolean | undefined;

    dateDiffMetric: string = '';
    dateDiff: number = 0;

    notification: boolean = false;
    isRead: boolean = false;

    constructor(alert: Alert, isNotification: boolean = false) {
        this.assignedTo = alert.assignedTo;
        this.body = alert.body;
        this.createdBy = alert.createdBy;
        this.createdByName = alert.createdByName;
        this.creationDate = new Date(alert.creationDate);
        this.highPriority = alert.highPriority;
        this.id = alert.id;
        this.readDate = new Date(alert.readDate!);
        this.relatedData = alert.relatedData;
        this.relatedDataId = alert.relatedDataId;
        this.toRedirect = alert.toRedirect;

        this.notification = isNotification;
        
        this.calculateDateTimeDiff(this.creationDate);
    }

    public calculateDateTimeDiff(dateToCompare?: Date) {
        let currentDate = new Date();

        if (!dateToCompare) {
            dateToCompare = this.creationDate;
        }

        let milisecondsDifference = currentDate.getTime() - dateToCompare.getTime();

        let second_s = Math.round(milisecondsDifference / 1000);
        let minute_s = Math.round(second_s / 60);
        let hour_s = Math.round(minute_s / 60);
        let day_s = Math.round(hour_s / 24);
        let month_s = Math.round(day_s / 30);
        let year_s = Math.round(month_s / 12);

        let dateDiffs = {
            YEAR_S: year_s,
            MONTH_S: month_s,
            DAY_S: day_s,
            HOUR_S: hour_s,
            MINUTE_S: minute_s,
            SECOND_S: second_s, 
        }

        let firstEntryWithValue = Object.entries(dateDiffs).find(([dateDiffMetric, dateDiff]) => dateDiff >= 1)!;

        this.dateDiffMetric = firstEntryWithValue[0];
        this.dateDiff = firstEntryWithValue[1];
    }
}